import { router } from "expo-router";
import { View, Text, Button } from "@src/components";

interface AccountNotConfiguredViewProps {
  error?: string | null;
  onRetry: () => void;
}

export function AccountNotConfiguredView({ error, onRetry }: AccountNotConfiguredViewProps) {
  return (
    <View flex={1} alignItems="center" justifyContent="center" bg="background" px="6xl" gap="lg">
      <Text textStyle="xl" fontWeight="600" textAlign="center">
        Account not configured
      </Text>
      <Text textStyle="md/regular" color="textMuted" textAlign="center">
        {error || "Your account isn't linked to any organisations yet. Please contact your administrator."}
      </Text>
      <Button label="Try Again" variant="primary" onPress={onRetry} />
      <Button label="Logout" variant="secondary" onPress={() => router.push("/auth/logout")} />
    </View>
  );
}
